import { CopyToClipboardButton } from "common/CopyToClipboard/CopyToClipboard";
import { useTheme } from "styled-components";

interface CopyLinkProps {
  url: string;
  linkWidth: number;
  linkName: string;
}

const CopyLink = ({ url, linkWidth, linkName }: CopyLinkProps) => {
  const appTheme = useTheme();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <span
        style={{
          color: appTheme.colors.secondaryGrey,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: linkWidth,
          border: appTheme.borders.lightest,
          padding: "12px",
          borderRadius: "12px",
          background: appTheme.colors.lightBackground,
        }}
      >
        {url}
      </span>
      <CopyToClipboardButton
        name={linkName}
        style={{ marginLeft: 12 }}
        text={url}
      />
    </div>
  );
};

export default CopyLink;
